// Örnek servis codiagno login
import axios from "../javascript/custom-axios";
const RESOURCE_NAME = "/admin";

export default {
  //   getProfile(id) {
  //     return axios.get(`${RESOURCE_NAME}/Id`, { params: { id: id } });
  //   },
  getStatistics(id) {
    return axios.get(`${RESOURCE_NAME}/statisticsQuery`);
  },
  getReport(
    key,
    startDate = "",
    endDate = "",
    type = "",
    pageSize = 15,
    page = 1,
    isExcel = false,
    groupId = ""
  ) {
    var params = `/statistics?Key=${key}&Type=${type}&StartDate=${startDate}&EndDate=${endDate}&PageSize=${pageSize}&Page=${page}&ForExcel=${isExcel}&GroupId=${groupId}`;

    if (isExcel) {
      axios.defaults.timeout = 90000000000;
    } else {
      axios.defaults.timeout = 40 * 1000;
    }

    return axios.get(`${RESOURCE_NAME}${params}`, {
      responseType: isExcel ? "blob" : "",
    });
  },
  //   updateMyProfile(body) {
  //     return axios.put(`${RESOURCE_NAME}/profile`, body);
  //   },
  //   createCurrentSellerAddress(body) {
  //     return axios.post(`/selleraddress`, body);
  //   },
};
